import {
	HomeOutlined,
	UserOutlined,
	UsergroupAddOutlined,
	LineChartOutlined,
	ToolOutlined,
	CodeOutlined,
	SettingOutlined,
	SnippetsOutlined,
	TagOutlined,
	AppstoreOutlined,
	RocketOutlined,
	PlusOutlined,
	FileZipOutlined,
	BarChartOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
	PermissaoGrupoUsuarioEnum,
	PermissaoUsuarioEnum,
	PermissaoEmpresaEnum,
	PermissaoProdutoEnum,
	PermissaoTesteUnitarioEnum,
	PermissaoConfiguracaoTesteEnum,
	PermissaoCategoriaProdutoEnum,
	PermissaoModeloJigaEnum,
	PermissaoUnidadeEmpresaEnum,
	PermissaoJigaEnum,
	PermissaoLogTesteEnum,
	PermissaoCategoriaComponenteEnum,
	PermissaoComponenteEnum,
	PermissaoDashboardTesteEnum,
	PermissaoCategoriaMidiaEnum,
	PermissaoMidiaEnum,
} from "enum/permissao-enum";

const dashBoardNavTree = [
	{
		key: "home",
		path: `${APP_PREFIX_PATH}/home`,
		title: "home",
		icon: HomeOutlined,
		breadcrumb: false,
		submenu: [],
	},
	{
		key: "dashboard-testes",
		path: `${APP_PREFIX_PATH}/dashboard-testes`,
		title: "dashboard-testes",
		icon: LineChartOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoDashboardTesteEnum.VISUALIZAR_TODOS,
			PermissaoDashboardTesteEnum.VISUALIZAR_APENAS_EMPRESA,
		],
	},
	{
		key: "estatisticas",
		path: `${APP_PREFIX_PATH}/estatisticas`,
		title: "estatisticas",
		icon: BarChartOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoLogTesteEnum.VISUALIZAR,
			PermissaoLogTesteEnum.VISUALIZAR_APENAS_EMPRESA,
			PermissaoLogTesteEnum.VISUALIZAR_APENAS_UNIDADE_EMPRESA,
		],
	},
	{
		key: "testes",
		path: `${APP_PREFIX_PATH}/testes`,
		title: "testes",
		icon: RocketOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoLogTesteEnum.RODAR_TESTE,
	},
	{
		key: "lista-usuarios",
		path: `${APP_PREFIX_PATH}/lista-usuarios`,
		title: "lista-usuarios",
		icon: UserOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoUsuarioEnum.VISUALIZAR,
	},
	{
		key: "lista-jigas",
		path: `${APP_PREFIX_PATH}/lista-jigas`,
		title: "lista-jigas",
		icon: ToolOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoJigaEnum.VISUALIZAR,
			PermissaoJigaEnum.VISUALIZAR_APENAS_EMPRESA,
			PermissaoJigaEnum.VISUALIZAR_APENAS_UNIDADE_EMPRESA,
		],
	},
	{
		key: "lista-testes-unitarios",
		path: `${APP_PREFIX_PATH}/lista-testes-unitarios`,
		title: "lista-testes-unitarios",
		icon: CodeOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoTesteUnitarioEnum.VISUALIZAR,
	},
	{
		key: "lista-configuracoes-teste",
		path: `${APP_PREFIX_PATH}/lista-configuracoes-teste`,
		title: "lista-configuracoes-teste",
		icon: SettingOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoConfiguracaoTesteEnum.VISUALIZAR,
			PermissaoConfiguracaoTesteEnum.VISUALIZAR_APENAS_EMPRESA,
		],
	},
	{
		key: "lista-logs-teste",
		path: `${APP_PREFIX_PATH}/lista-logs-teste`,
		title: "lista-logs-teste",
		icon: SnippetsOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoLogTesteEnum.VISUALIZAR,
			PermissaoLogTesteEnum.VISUALIZAR_APENAS_EMPRESA,
			PermissaoLogTesteEnum.VISUALIZAR_APENAS_UNIDADE_EMPRESA,
		],
	},
	{
		// showTitle: false,
		title: "secundario",
		submenu: [
			{
				key: "cadastro-secundario",
				title: "cadastro-secundario",
				breadcrumb: false,
				icon: PlusOutlined,
				submenu: [
					{
						key: "lista-grupos-usuario",
						path: `${APP_PREFIX_PATH}/lista-grupos-usuario`,
						title: "lista-grupos-usuario",
						icon: UsergroupAddOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoGrupoUsuarioEnum.VISUALIZAR,
					},
					{
						key: "lista-empresas",
						path: `${APP_PREFIX_PATH}/lista-empresas`,
						title: "lista-empresas",
						icon: HomeOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoEmpresaEnum.VISUALIZAR,
					},
					{
						key: "lista-unidades-empresa",
						path: `${APP_PREFIX_PATH}/lista-unidades-empresa`,
						title: "lista-unidades-empresa",
						icon: HomeOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoUnidadeEmpresaEnum.VISUALIZAR,
					},
					{
						key: "lista-categorias-produto",
						path: `${APP_PREFIX_PATH}/lista-categorias-produto`,
						title: "lista-categorias-produto",
						icon: TagOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoCategoriaProdutoEnum.VISUALIZAR,
					},
					{
						key: "lista-produtos",
						path: `${APP_PREFIX_PATH}/lista-produtos`,
						title: "lista-produtos",
						icon: TagOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: [
							PermissaoProdutoEnum.VISUALIZAR,
							PermissaoProdutoEnum.VISUALIZAR_APENAS_EMPRESA,
						],
					},
					{
						key: "lista-modelos-jiga",
						path: `${APP_PREFIX_PATH}/lista-modelos-jiga`,
						title: "lista-modelos-jiga",
						icon: ToolOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoModeloJigaEnum.VISUALIZAR,
					},
					{
						key: "lista-categoria-componente",
						path: `${APP_PREFIX_PATH}/lista-categoria-componente`,
						title: "lista-categoria-componente",
						icon: AppstoreOutlined,
						breadcrumb: false,
						submenu: [],
						permissao:
							PermissaoCategoriaComponenteEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-componente",
						path: `${APP_PREFIX_PATH}/lista-componente`,
						title: "lista-componente",
						icon: AppstoreOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: [
							PermissaoComponenteEnum.VISUALIZAR_TODOS,
							PermissaoComponenteEnum.VISUALIZAR_APENAS_EMPRESA,
						],
					},
					{
						key: "lista-categoria-midia",
						path: `${APP_PREFIX_PATH}/lista-categoria-midia`,
						title: "lista-categoria-midia",
						icon: FileZipOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: PermissaoCategoriaMidiaEnum.VISUALIZAR_TELA,
					},
					{
						key: "lista-midia",
						path: `${APP_PREFIX_PATH}/lista-midia`,
						title: "lista-midia",
						icon: FileZipOutlined,
						breadcrumb: false,
						submenu: [],
						permissao: [
							PermissaoMidiaEnum.VISUALIZAR_TODOS,
							PermissaoMidiaEnum.VISUALIZAR_APENAS_EMPRESA,
						],
					},
				],
			},
		],
	},
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
